export const normalizeString = (s?: string | null) => s?.trim() || undefined;

export function pascalToTitleCase(value: string): string {
  const normalized = value.trim();

  if (normalized === normalized.toUpperCase()) {
    return normalized
      .toLowerCase()
      .replace(/\b\w/g, (char) => char.toUpperCase());
  }

  const titleCase = normalized.replace(/([A-Z])/g, " $1").trim();

  if (titleCase.includes(" ")) {
    return titleCase;
  }

  return titleCase.charAt(0).toUpperCase() + titleCase.slice(1);
}
